export default "__VITE_ASSET__C8ppObM7__"